import ScrollReveal from 'scrollreveal'
import { Swiper, Navigation, EffectFade, Pagination } from 'swiper'

Swiper.use([Navigation, EffectFade, Pagination])

const $sliders = document.querySelectorAll('[data-slider]')

const fn = {
    init: () => {
        $sliders.forEach(($slider) => {
            fn.setupSlider($slider)
        })
    },

    setupSlider: ($slider) => {
        if ($slider.querySelectorAll('.swiper-slide').length < 2) {
            return
        }

        const breakpoints = {}

        if ($slider.dataset.sliderMd) {
            const opts = JSON.parse($slider.dataset.sliderMd)

            breakpoints['768'] = opts
        }

        if ($slider.dataset.sliderLg) {
            const opts = JSON.parse($slider.dataset.sliderLg)

            breakpoints['1024'] = opts
        }

        new Swiper($slider, {
            on: {
                init: () => {
                    ScrollReveal().sync()
                },
            },
            autoHeight: true,
            loop: true,
            loopFillGroupWithBlank: true,
            effect: $slider.dataset.sliderFade !== undefined ? 'fade' : 'slide',
            fadeEffect: {
                crossFade: true,
            },
            pagination: {
                el: $slider.querySelector('.slider-pagination'),
                clickable: true,
            },
            navigation: {
                prevEl: $slider.querySelector('.slider-prev'),
                nextEl: $slider.querySelector('.slider-next'),
            },
            breakpoints,
        })
    },
}

export const Slider = {
    setupSlider: fn.setupSlider,
}

export default {
    can: () => $sliders.length,
    run: fn.init,
}
